<template>
    <div class="Detail_container">
        <div class="match_info">
            <div class="name">
                {{Description.FullName}}
                <YD-image :src="`match_detail/${CurrentCertificate.Level}级赛事`" v-if="CurrentCertificate.Level"></YD-image>
            </div>
            <div class="date">
                <template v-if="CurrentCertificate.Level">
                    <p class="look_certificate" @click="lookOverCertificate(CurrentCertificate.CertificateNumber)">查看证书<YD-image src="icon/icon_card_arrow_2"></YD-image></p>
                    <i v-if="(GameTime.BeginTime && GameTime.EndTime) || [2,3].includes(subLeagueData.AbnormalStatus)">/</i>
                </template>
                <p v-if="GameTime.BeginTime && GameTime.EndTime">{{GameTime.BeginTime | dateFormat('yyyy年M月d日')}} - {{GameTime.EndTime | dateFormat('yyyy年M月d日')}}</p>
                <p v-else>{{['','','比赛时间待定','恢复时间待定'][subLeagueData.AbnormalStatus]}}</p>
            </div>
            <div class="location">
                <div>
                    <YD-image src="icon/定位"></YD-image>
                </div>
                <p v-html="subLeagueData.GamePlace ? subLeagueData.GamePlace.join(`<i style='font-style: normal;color: #C8C8C8;font-weight: 400;margin:0 8px;'>/</i>`) : '未知'"></p>
            </div>
            <div class="board" v-if="subLeagueData.IsPublic">
                <div>
                    <span>报名公示</span>
                    <p>比赛开始前公示{{publicDay}}天</p>
                </div>
                <div v-href="'/Enroll/BulletinBoard?subLeagueId=' + subLeagueData.SubLeagueId">
                    <span>浏览</span>
                    <YD-image src="icon/icon_card_arrow_2"></YD-image>
                </div>
            </div>
        </div>
        <div class="status" v-if="statusInfo">
            <div class="img" :style="statusInfo.bubbleStyle">
                <YD-image :src="'match_detail/' + statusInfo.bubbleUrl"></YD-image>
                <div class="time">{{statusInfo.bubbleText}}</div>
            </div>
            <div class="progress_bar">
                <p :class="'progress_' + statusInfo.progress"></p>
                <div class="node">
                    <YD-image v-for="(item,index) in statusInfo.progressDot" :key="index" :src="'match_detail/' + item"></YD-image>
                </div>
            </div>
            <p class="text">
                <span v-for="(item,index) in statusInfo.progressText" :key="index" 
                    :class="{
                        [statusInfo.progressTextClass] : (index+1) == statusInfo.progress,
                        'old_status': (index+1) < statusInfo.progress
                    }"
                >{{item}}</span>
            </p>
        </div>
		<div class="groupQRCode" v-if="subLeagueData.IsHaveMatchGroup">
			<div class="content">
				<YD-image src="icon/icon_group"></YD-image>
				<div>
					<div class="title">参赛群</div>
					<p>加入官方交流微信群</p>
				</div>
			</div>
			<div class="button" @click="go2GroupQRCode()">前往</div>
		</div>
        <div class="unit" v-if="Units">
            <p class="type_title">
                <span class="type_name">组织机构</span>
                <span></span>
            </p>
            <ul>
                <li v-for="(item,index) in Units" :key="index">
                    <div class="unit_type" :style="item.Kind == '主办单位' ? 'color: #F06E43;background: #FFE9E2;' : ''">{{item.Kind}}</div>
                    <div class="unit_list">
                        <div v-for="(unitItem,unitIndex) in item.Units" :key="unitIndex">{{unitItem}}</div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="detail">
            <p class="type_title">
                <span class="type_name">赛事详情</span>
                <span></span>
            </p>
            <div class="detail_content rich_text"
                ref="detailContent"
                v-html="Comment"
                v-if="Comment"
            ></div>
			<div class="image_list" v-if="subLeagueData.PictureFiles">
				<img :src="item.FileUrl" v-for="(item, index) in subLeagueData.PictureFiles" :key="index" @click="previewImage(item.FileUrl, imageUrls)" />
			</div>
			<div class="file_list" v-if="subLeagueData.DocFiles">
				<div class="file_item" v-for="(item, index) in handleDocFiles" :key="index" @click="openFile(item.url, item.name)">
					<div class="file_icon" :class="item.className"></div>
					<div class="file_info">
						<div class="file_name">{{item.name}}</div>
						<div class="file_size">{{item.size}}</div>
					</div>
				</div>
			</div>
        </div>
        <div id="certificate" v-show="certificateShow" @click="()=>{this.certificateShow = false}">
            <div class="certificate_modal">
                <div class="certificate_content" >
                    <YD-image class="medal" :src="'certificate/icon_证书_'+certificateInfo.Level+'级赛事'"></YD-image>
                    <div class="competition_name">
                        <div class="competition_name-content">
                            <p v-for="item in LeagueNames" :key="item">{{item}}</p>
                        </div>
                    </div>
                    <YD-image class="grade" :src="'certificate/文字_'+certificateInfo.Level+'级赛事'"></YD-image>
                    <div class="certificate_serialNumber">证书编号：{{certificateInfo.CertificateNumber}}</div>
                    <div class="certificate_date">{{certificateInfo.IssueDate | dateFormat('yyyy年MM月dd日')}}</div>
                    <div class="certificate_stamp"></div>
                </div>
            </div>
        </div>   
    </div>
</template>
<script>
import {
    GetLeagueCertificate
} from "@/api"
import {
    dateFormat
} from '@js';
import appInteraction from '@/common/appInteraction';
import tools from '@/common/tools';
export default {
    props:{
        subLeagueData:{
            type: Object,
            default: {}
        }
    },
    data(){
        return {
            certificateInfo:{},//证书信息
            certificateShow:false,//证书显示
        }
    },
    watch:{
        Comment:{
            immediate: true,
            handler(newValue){
                if(newValue){
                    this.setCommentImage();
                }
            }
        }
    },
    computed:{
        Description(){ return this.subLeagueData.Description || {}},
        GameTime(){ return this.subLeagueData.GameTime || {}},
        CurrentCertificate(){ return this.subLeagueData.CurrentCertificate || {}},
        EnrollTime(){ return this.subLeagueData.EnrollTime || {}},
        Units(){
            if(!this.subLeagueData.AllUnits) return;
            let units = this.subLeagueData.AllUnits;
            return units;
        },
        Comment(){
            const reg = new RegExp(/[0-9]+px/,'igm');
            if(this.subLeagueData.Comment){
                return this.subLeagueData.Comment.replace(reg,(matching)=>{
                    var num = parseInt(matching.substr(0,matching.length - 2));
                    return (26 / 16 * num / 100) + 'rem;' + 'line-height:1.6em';
                });
            }else{
                return '';
            }
        },
        imageUrls(){
			if(!this.subLeagueData.PictureFiles) return [];
			return this.subLeagueData.PictureFiles.map(item=>item.FileUrl);
		},
		handleDocFiles(){
			if(!this.subLeagueData.DocFiles) return [];
			return this.subLeagueData.DocFiles.map(item=>{
				let name = item.FileName,
					url = item.FileUrl;
				let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
				if(!type){
					type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
				}
				let className = type;
				if(['docx', 'doc'].includes(type)){
					className = 'word';
				}else if(['xlsx', 'xls'].includes(type)){
					className = 'excel';
				}else if(['pptx', 'ppt'].includes(type)){
					className = 'ppt';
				}else if(['pdf'].includes(type)){
					className = 'pdf';
				}
				return {
					url,
					name,
					type,
					size: tools.formatFileSize(item.FileSize),
					className
				}
			})
		},
        publicDay(){
            if(this.subLeagueData.IsPublic){
                let BeginTime = new Date(this.subLeagueData.PublicBeginTime).getTime(),
                    EndTime = new Date(this.subLeagueData.PublicEndTime).getTime();
                return Math.ceil((EndTime - BeginTime) / 1000 / 60 / 60 / 24);
            }else{
                return '';
            }
        },
        statusInfo(){
            var bubbleStyle,
                bubbleUrl,
                progress,
                progressText = ['报名中','未开赛','比赛中','已结束'],
                bubbleText,
                progressDot = [],
                progressTextClass = "active";
            var data = this.subLeagueData;
            if(!data.SubLeagueId) return;
            if(data.AbnormalStatus == 1){
                bubbleStyle = "width: 4.26rem;height: 1rem;left: 1.34rem";
                bubbleUrl = "气泡_2";
                bubbleText = '此赛事已取消~';
                progress = 0;
            }else if(data.AbnormalStatus == 3  && data.Status == 3 && data.GameTime){
                bubbleStyle = "width: 5.72rem;height: 1rem;right: 0.43rem;";
                bubbleUrl = "气泡_4";
                bubbleText = `赛事恢复时间：${dateFormat(data.GameTime.BeginTime, 'yyyy年M月d日')} - ${dateFormat(data.GameTime.EndTime, 'yyyy年M月d日')}`;
                progress = 3;
                progressText[2] = '比赛中断';
                progressTextClass = "active_2";
            }else if([2,3].includes(data.AbnormalStatus) && ![1,2].includes(data.Status) && !data.GameTime){
                if(data.AbnormalStatus == 2){
                    bubbleStyle = "width: 4.26rem;height: 1rem;left: 0.33rem";
                    bubbleUrl = "气泡_2";
                    bubbleText = '赛事延期，比赛时间待定~';
                    progress = 2;
                }else if(data.AbnormalStatus == 3){
                    bubbleStyle = "width: 4.26rem;height: 1rem;right: 0.33rem";
                    bubbleUrl = "气泡_2";
                    bubbleText = '赛事中断，恢复时间待定~';
                    progress = 3;
                    progressText[2] = '比赛中断';
                    progressTextClass = "active_2";
                }
            }else if([1,2].includes(data.Status)){
                bubbleStyle = "width: 4.6rem;height: 1.04rem;left: 0.14rem;";
                bubbleUrl = "气泡_1";
                if(data.Status == 2){
                    bubbleText = `${dateFormat(data.EnrollTime.BeginTime, 'yyyy年M月d日')} - ${data.EnrollTime.EndTime ? dateFormat(data.EnrollTime.EndTime, 'yyyy年M月d日') : '暂无截止日期'}`;
                }else{
                    bubbleText = `报名开始时间：${dateFormat(data.EnrollTime.BeginTime, 'yyyy年M月d日')}`;
                    progressText[0] = '未开始';
                }
                progress = 1;
            }else if(data.Status == 3){
                bubbleStyle = "width: 4.26rem;height: 1rem;left: 0.33rem";
                bubbleUrl = "气泡_2";
                bubbleText = `${dateFormat(data.GameTime.BeginTime, 'yyyy年M月d日')} - ${dateFormat(data.GameTime.EndTime, 'yyyy年M月d日')}`;
                progress = 2;
            }else if(data.Status == 4){
                bubbleStyle = "width: 4.26rem;height: 1rem;right: 0.33rem";
                bubbleUrl = "气泡_2";
                bubbleText = `${dateFormat(data.GameTime.BeginTime, 'yyyy年M月d日')} - ${dateFormat(data.GameTime.EndTime, 'yyyy年M月d日')}`;
                progress = 3;
            }else if(data.Status == 5){
                bubbleStyle = "width: 4.6rem;height: 1.02rem;right: 0.14rem;";
                bubbleUrl = "气泡_3";
                bubbleText = '比赛已结束~请查看比赛排名';
                progress = 4;
            }
            for(var i = 1;i <= 4;i++){
                if(i < progress){
                    progressDot.push('点_' + i);
                }else if(i == progress){
                    progressDot.push('点_active');
                }else{
                    progressDot.push('点_disabled');
                }
            }
            return {
                bubbleStyle,
                bubbleUrl,
                progress,
                progressText,
                bubbleText,
                progressDot,
                progressTextClass
            }
        },
        LeagueNames(){
            let {
                LeagueNameByLines,
                LeagueName
            } = this.certificateInfo;
            if(LeagueNameByLines){
                return LeagueNameByLines.split(',');
            }
            return [LeagueName];
        }
    },
    methods:{
        setCommentImage(){
            this.$nextTick(function(){
                if(!this.$refs.detailContent) return;
                let images = [],
                    imageDom = this.$refs.detailContent.querySelectorAll('img');
                if(imageDom.length > 0){
                    imageDom.forEach((item) => {
                        let url = item.getAttribute('src');
                        images.push(url);
                        item.onclick = ()=>{
                            this.previewImage(url, images);
                        }
                    });
                }
            });
        },
        lookOverCertificate(CertificateNumber){
            if(CertificateNumber){
                 GetLeagueCertificate({
                    CertificateNumber
                }).then(data=>{
                    if(data.Code == 0){
                        this.certificateInfo = data.LeagueCertificate;
                        this.certificateShow = true;
                    }
                })
            }else{
                this.$Prompt({
                    title: '初审评定',
                    message: `初审评定为${this.CurrentCertificate.Level}级赛事，终审通过后发放证书`,
                    confirmText: '关闭',
                    confirmColor: '#3A3F49'
                })
            }
        },
        go2GroupQRCode(){
            this.$Prompt({
                title: "群二维码",
                message: "点击“确定”将跳转到“亿动体育”小程序打开群二维码页面。",
                showCancel: true
            }).then(confirm=>{
                if(confirm){
                    appInteraction.jumpWxMiniApp(`/pages/Match/MatchDetail/MatchDetail?SubLeagueId=${this.subLeagueData.SubLeagueId}&go=groupQRCode`);
                }
            })
        },
        previewImage(url, urls){
			if(!url) return;
			if(!urls){
				urls = [url];
			}
            let index = urls.indexOf(url);
            this.$emit('lookImage', {
                list: urls,
                index: index,
                show: true
            });
        },
        //查看文件
        openFile(url, name){
            this.$navigation.go(`/Rules/OnlinePreview?file_url=${encodeURIComponent(url)}&name=${name}&download=1`);
        }
    }
}
</script>
<style lang="scss" scoped>
.Detail_container{
    height: auto;
    width: 100%;
    padding: 40px;
    box-sizing: border-box;
    .type_title{
        width: 100%;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 500;
        .type_name{
            font-size: 32px;
            color: #B9B9B9;
        }
        .text_btn{
            font-size: 26px;
            color: #7AD21A;
        }
    }
    .match_info{
        width: 100%;
        height: auto;
        position: relative;
        box-sizing: border-box;
        .name{
            line-height: 56px;
            font-size: 40px;
            color: #1B1C1E;
            font-weight: 500;
            img{
                width: 122px;
                height: 40px;
                margin-left: 8px;
                margin-top: 8px;
            }
        }
        .date{
            height: 40px;
            display: flex;
            align-items: center;
            margin-top: 16px;

            font-size: 28px;
            white-space: nowrap;
            i{
                font-style: normal;
                color: #C8C8C8;
                font-weight: 400;
                margin-right: 8px;
            }
            p{
                color: #000000;
                font-weight: 400;
            }
            .look_certificate{
                color: #7AD21A;
                font-weight: 500;
                display: flex;
                align-items: center;
                img{
                    width: 38px;
                }
            }
        }
        .location{
            width: 100%;
            min-height: 48px;
            display: flex;
            margin-top: 12px;
            font-size: 28px;
            color: #7E7E7F;
            font-weight: 400;
            line-height: 40px;
            div{
                height: 100%;
                margin-right: 10px;
                img{
                    width: 32px;
                    height: 32px;
                    margin-top: 4px;
                }
            }
            p{
                width: calc(100% - 50px);
            }
        }
    }
    .board{
        width: 100%;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #FFFFFF;
        box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
        border-radius: 16px;
        margin-top: 24px;
        div{
            font-size: 28px;
            color: #1B1C1E;
            font-weight: 400;
            display: flex;
            align-items: center;
            &:nth-of-type(1){
                span{
                    width: 164px;
                    color: #F06E43;
                    font-weight: 500;
                    padding-left: 32px;
                    box-sizing: border-box;
                    position: relative;
                    &::after{
                        content: '';
                        height: 24px;
                        border-right: 4px solid #F0F0F0;
                        position: absolute;
                        top: 50%;
                        margin-top: -12px;
                        right: 0;
                    }
                }
                p{
                    width: 360px;
                    padding-left: 16px;
                    box-sizing: border-box;
                }
            }
            &:nth-of-type(2){
                color: #7AD21A;
                font-weight: 500;
                padding-right: 24px;
                img{
                    width: 32px;
                    height: 32px;
                }
            }
        }
    }
    .status{
        width: 100%;
        height: 194px;
        margin-top: 32px;
        background: #FFFFFF;
        box-shadow: 0 10px 19px 0 #EBF2F5;
        border-radius: 20px;
        padding-top: 116px;
        box-sizing: border-box;
        position: relative;
        .img{
            position: absolute;
            top: 12px;
            img{
                width: 100%;
                height: 100%;
            }
            .time{
                width: calc(100% - 30px);
                @include line-height(34px);
                font-size: 24px;
                color: #FFFFFF;
                text-align: center;
                text-shadow: 0 1px 2px rgba(48,66,137,0.11);
                font-weight: 500;
                white-space: nowrap;
                position: absolute;
                top: 26px;
                left: 15px;
            }
        }
        .progress_bar{
            width: 538px;
            height: 4px;
            background: #E5E8E1;
            margin: 0 auto;
            position: relative;
            p{
                width: 0%;
                height: 100%;
                &.progress_2{
                    width: 33.3333%;
                    background-image: linear-gradient(270deg, #7AD21A 2%, #29D268 50%, #00C2DC 98%);
                }
                &.progress_3{
                    width: 66.6666%;
                    background-image: linear-gradient(-89deg, #7AD21A 2%, #29D268 50%, #00C2DC 99%);
                    
                }
                &.progress_4{
                    width: 100%;
                    background-image: linear-gradient(-89deg, #7AD21A 2%, #29D268 50%, #00C2DC 99%);
                    
                }
            }
            .node{
                width: calc(100% + 28px);
                height: 28px;
                position: absolute;
                left: -14px;
                top: -12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                img{
                    height: 28px;
                    width: 28px;
                }
            }
        }
        .text{
            width: 100%;
            height: 36px;
            margin-top: 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span{
                width: 134px;
                font-size: 26px;
                color: #7E7E7F;
                font-weight: 400;
                line-height: 34px;
                text-align: center;
                &.active{
                    color:#7AD21A;
                    font-weight: 500;
                }
                &.active_2{
                    color:#3A3F49;
                    font-weight: 500;
                }
                &.old_status{
                    color: #3A3F49;
                }
            }
        }
    }
    .groupQRCode{
        width: 666px;
        height: 124px;
        background: #F4FBFF;
        border-radius: 74px;
        margin-left: 4px;
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .content{
            display: flex;
            align-items: center;
            img{
                width: 92px;
                height: 92px;
                margin-left: 16px;
                margin-right: 24px;
            }
            .title{
                font-family: PingFangSC-Medium;
                font-size: 32px;
                color: #379BFA;
                font-weight: 500;
                line-height: 44px;
            }
            p{
                font-family: PingFangSC-Regular;
                font-size: 28px;
                color: #A1A1A1;
                font-weight: 400;
                line-height: 40px;
            }
        }
        .button{
            width: 120px;
            height: 60px;
            background-image: linear-gradient(180deg, #57ABFC 0%, #1F8FF9 100%);
            border-radius: 30px;
            margin-right: 32px;
            font-family: PingFangSC-Medium;
            font-size: 28px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 60px;
            font-weight: 500;
            text-align: center;
        }
    }
    .unit{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        margin-top: 56px;
        ul{
            margin-top: 20px;
            li{
                width: 100%;
                height: auto;
                padding: 12px 0 4px;
                display: flex;
                .unit_type{
                    width: 126px;
                    @include line-height(40px);
                    background: #FEF1CD;
                    font-size: 24px;
                    color: #F79611;
                    font-weight: 400;
                    text-align: center;
                    margin-right: 16px;
                    margin-top: 3px;
                    border-radius: 20px;
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 16px;
                    flex: none;
                }
                .unit_list{
                    width: calc(100% - 142px);
                    height: auto;
                    div{
                        width: 100%;
                        height: auto;
                        margin-bottom: 8px;

                        line-height: 40px;
                        font-size: 28px;
                        color: #585D65;
                        font-weight: 400;
                    }
                }
            }
        }
    }
    .detail{
        margin-top: 56px;
        .detail_content{
            margin-top: 24px;
            & + .image_list,
            & + .file_list{
                margin-top: 16px;
            }
        }
    }
    .image_list{
        width: 100%;
        height: auto;
        img{
            display: block;
            width: auto;
            max-width: 100%;
            height: auto;
			border-radius: 12px;
            margin: 0 auto;
            margin-bottom: 16px;
        }
    }
    .file_list{
        width: 100%;
        height: auto;
        .file_item{
            width: 100%;
            min-height: 108px;
            padding: 16px 24px;
            box-sizing: border-box;
            background: #FAFBFA;
            border-radius: 12px;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            &:last-of-type{
                margin-bottom: 0;
            }
            .file_icon{
                width: 76px;
                height: 76px;
                background: no-repeat center / 100%;
                &.word{
                    background-image: url('~@/assets/images/icon/file_word@2x.png');
                }
                &.pdf{
                    background-image: url('~@/assets/images/icon/file_pdf@2x.png');
                }
                &.excel{
                    background-image: url('~@/assets/images/icon/file_excel@2x.png');
                }
                &.ppt{
                    background-image: url('~@/assets/images/icon/file_ppt@2x.png');
                }
            }
            .file_info{
                width: calc(100% - 76px);
                padding-left: 12px;
                box-sizing: border-box;
                .file_name{
                    width: 100%;
                    font-weight: 400;
                    font-size: 28px;
                    color: #3A3F49;
                    line-height: 44px;
                }
                .file_size{
                    font-weight: 400;
                    font-size: 24px;
                    color: #8B8C8D;
                    line-height: 30px;
                }
            }
        }
    }
    @include certificate;
}
</style>
<style lang="scss">
@import '@assets/scss/richText.scss';
</style>